
import {LOGIN, ROUTES} from '@/services/api'
import { removeToken } from '@/utils/auth'
import {request, METHOD, removeAuthorization} from '@/utils/request'

/**
 * 登录服务
 * @param name 账户名
 * @param password 账户密码
 * @returns {Promise<AxiosResponse<T>>}
 */
export async function login(name, password) {
  return request(LOGIN, METHOD.POST, {
    name,
    password
  })
}

export async function getRoutesConfig() {
  return request(ROUTES, METHOD.GET)
}

/**
 * 退出登录
 */
const SessionKey = {
  ACCOUNTDATA: 'accountData',
  CUSTOMERNAME: 'customerName',
  BUTTONPERMISSION: 'buttonPermission',
}
window.onbeforeunload = function(){ 
  localStorage.removeItem(SessionKey.BUTTONPERMISSION)
}
export function logout() {
  sessionStorage.removeItem('getCreditTips')
  sessionStorage.removeItem('showCreditTips')
  sessionStorage.removeItem('creditPercentage')
  localStorage.removeItem(process.env.VUE_APP_ROUTES_KEY)
  localStorage.removeItem(process.env.VUE_APP_PERMISSIONS_KEY)
  localStorage.removeItem(process.env.VUE_APP_ROLES_KEY)
  localStorage.removeItem(SessionKey.ACCOUNTDATA)
  localStorage.removeItem(SessionKey.CUSTOMERNAME)
  localStorage.removeItem(SessionKey.BUTTONPERMISSION)
  removeToken()
  removeAuthorization()
}
export default {
  login,
  logout,
  getRoutesConfig
}
